<div class="container-fluid my-5">
    <!-- Table -->
    <div class="row">
        <div class="col">
            <div class="card shadow">
                <div class="card-header bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-6">
                            <h3 class="mb-0">Mes réservations</h3>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div class="table-responsive">
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                                <tr>
                                    <th scope="col">STUDIO</th>
                                    <th scope="col">DATE</th>
                                    <th scope="col">
                                        <select class="form-control" [(ngModel)]="selectedStatus" (change)="onChangeStatus($event)">
                                            <option value="">Tous</option>
                                            <option *ngFor="let entry of statusEntries" [value]="entry.key">{{
                                                entry.value.text }}</option>
                                        </select>

                                    </th>
                                    <th scope="col">Date de création</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let reservation of reservations">
                                    <td scope="row">
                                        <!-- <a [href]="redirectToWebflow('/details-studio?slug=')"
                                            target="_parent" class="btn btn-sm btn-outline-primary"><i class="fa fa-link"></i>
                                            {{reservation.studio_name}}
                                        </a> -->
                                        <strong>{{reservation.studio_name}}</strong>
                                    </td>
                                    <td>
                                        <strong>Nombre d'heures : </strong>{{ reservation.nbr_hours_reserved}}H<br>
                                        <strong>Debut : </strong>{{ dateWithoutTimeZone(reservation.start_date) | date:
                                        'dd-MM-yyyy HH:mm'}}<br>
                                        <strong>Fin : </strong>{{ dateWithoutTimeZone(reservation.end_date) | date:
                                        'dd-MM-yyyy
                                        HH:mm'}}
                                    </td>
                                    <td>
                                        <span class="{{ status[reservation.status]['class']}}">{{
                                            status[reservation.status]['text']}}</span>
                                    </td>
                                    <td>
                                        <span class="badge badge-info">{{ dateWithoutTimeZone(reservation.createdAt) | date:
                                            'dd-MM-yyyy'}}</span>
                                    </td>
                                    <td>
                                        <button type="button" (click)="navigateTo('mes-reservations/info/'+reservation.id)"
                                            class="btn btn-sm btn-icon-only text-info" title="Détails">
                                            <i class="fas fa-list"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-icon-only text-danger"
                                            title="Annuler" (click)="annuler(reservation)"
                                            *ngIf="reservation.show_button_cancel">
                                            <i class="fa-lg ni ni-fat-remove"></i>
                                        </button>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                        <!-- loading state -->
                        <p class="text-center font-weight-bold mt-3" *ngIf="loading">
                            Chargement...</p>
                        <p class="text-center font-weight-bold mt-3" *ngIf="reservations.length == 0 && !loading">
                            Aucun élément trouvé</p>
                        <div class="w-100 text-center my-3">
                            <button class="btn btn-outline-dark" (click)="get_more()" *ngIf="has_more && !loading">Voir
                                plus</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>